import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cartList: []
  },
  mutations: {
    addCart(state, goods) {
      state.cartList.push(goods)
    }
  },
  actions: {},
  getters: {}
})
